"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverflow = void 0;
var _esToolkit = require("es-toolkit");
var _react = require("react");
const useOverflow = ({
  ref
}) => {
  const checkOverflow = (0, _react.useCallback)(() => {
    if (ref.current) {
      return ref.current.scrollHeight > ref.current.clientHeight;
    }
    return false;
  }, [ref]);
  const subscribe = (0, _react.useCallback)(callback => {
    const debouncedCallback = (0, _esToolkit.debounce)(callback, 100);
    window.addEventListener('resize', debouncedCallback);
    return () => {
      window.removeEventListener('resize', debouncedCallback);
      debouncedCallback.cancel();
    };
  }, []);
  const isOverflow = (0, _react.useSyncExternalStore)(subscribe, checkOverflow, checkOverflow);
  return {
    isOverflow
  };
};
exports.useOverflow = useOverflow;
